<template>
  <div class="filter-wrapper rounded overflow-hidden bg-white border mb-3 no-print" id="filters">
    <div class="d-flex justify-content-center align-items-center bg-light p-3">
      <font-awesome-icon
        :icon="['fas', 'filter']"
        class="mr-1"
      ></font-awesome-icon>
      <span>Filtros</span>
    </div>
    <div class="p-3">
      <div class="row mb-3">
        <div class="col-lg-10">
          <div class="row">
            <div class="col-lg-3 col-md-6">
              <div class="form-group mb-1">
                <label>Tag Ambra</label>
                <input
                  type="text"
                  v-model="filters.ambra_tag"
                  class="form-control form-control-sm"
                  id="tag-ambra"
                />
              </div>

              <div class="form-group mb-1">
                <label>Tag do espaço confinado</label>
                <input
                  type="text"
                  v-model="filters.confined_space_tag"
                  class="form-control form-control-sm"
                  id="tag-confined-space"
                />
              </div>

              <div class="form-group mb-1">
                <label>Tipo do espaço confinado</label>

                <Dropdown
                  v-model="filters.confined_space_type_id"
                  :options="non_paginated_confined_space_types"
                  :filter="true"
                  option-label="name"
                  option-value="id"
                  placeholder=""
                  filter-placeholder=""
                  data-key="id"
                  empty-message="Nenhum item encontrado"
                  empty-filter-message="Nenhum item encontrado"
                  class="dropdown-filter"
                />
              </div>
            </div>

            <div class="col-lg-3 col-md-6">
              <div class="form-group mb-1">
                <label>Setor</label>

                <Dropdown
                  v-model="filters.sector_name"
                  :options="company_sectors"
                  :filter="true"
                  option-label="name"
                  option-value="id"
                  placeholder="Todos"
                  filter-placeholder=""
                  empty-message="Nenhum item encontrado"
                  empty-filter-message="Nenhum item encontrado"
                  class="dropdown-filter"
                  @change="onChangeSector"
                />
              </div>

              <div class="form-group mb-1">
                <label>Área</label>

                <Dropdown
                  v-model="filters.area_name"
                  :options="company_areas"
                  :filter="true"
                  option-label="name"
                  option-value="id"
                  placeholder="Todos"
                  filter-placeholder=""
                  empty-message="Nenhum item encontrado"
                  empty-filter-message="Nenhum item encontrado"
                  class="dropdown-filter"
                  @change="onChangeArea"
                />
              </div>

              <div class="form-group mb-1">
                <label>Complemento</label>

                <Dropdown
                  v-model="filters.complement_name"
                  :options="company_complements"
                  :filter="true"
                  option-label="name"
                  option-value="id"
                  placeholder="Todos"
                  filter-placeholder=""
                  empty-message="Nenhum item encontrado"
                  empty-filter-message="Nenhum item encontrado"
                  class="dropdown-filter"
                />
              </div>
            </div>

            <div class="col-lg-3 col-md-6">
              <div class="form-group mb-1">
                <label>Id (de)</label>
                <input
                  type="text"
                  v-model="filters.id_from"
                  class="form-control form-control-sm"
                  id="id-from"
                />
              </div>

              <div class="form-group mb-1">
                <label>Id (até)</label>
                <input
                  type="text"
                  v-model="filters.id_to"
                  class="form-control form-control-sm"
                  id="id-to"
                />
              </div>

              <div class="form-group mb-1">
                <label>Id do espaço confinado</label>
                <input
                  type="text"
                  v-model="filters.confined_space_id"
                  class="form-control form-control-sm"
                  id="confined-space-id"
                />
              </div>
            </div>

            <div class="col-lg-3 col-md-6">
              <div class="form-group mb-1">
                <label>Categoria de Risco</label>
                <div>
                  <MultiSelect
                    v-model="filters.adequacy_status"
                    :options="adequacy_status"
                    display="chip"
                    option-label="label"
                    option-value="value"
                    class="multiselect-custom"
                  >
                  </MultiSelect>
                </div>
              </div>

              <div class="form-group mb-1">
                <label>Ordenar Por</label>
                <select
                  v-model="filters.order_by"
                  class="form-control form-control-sm"
                >
                  <option value="1" selected>ID (crescente)</option>
                  <option value="2">ID (decrescente)</option>
                  <option value="3">Tag Ambra (crescente)</option>
                  <option value="4">Tag Ambra (decrescente)</option>
                </select>
              </div>

              <div class="form-group mb-1">
                <label>Pesquisar texto</label>
                <input
                  type="text"
                  v-model="filters.name"
                  class="form-control form-control-sm"
                  id="text-search"
                />
              </div>

              <div class="form-check mb-3 no-print">
                <div class="d-flex align-items-center">
                  <input
                    :value="0"
                    v-model="filters.show_only_selected_risk_categories"
                    class="form-check-input"
                    type="checkbox"
                    id="show_only_selected_risk_categories"
                  />
                  <label class="form-check-label" for="show_only_selected_risk_categories">
                    Exibir somente Categorias de Risco selecionadas
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-2 no-print">
          <div class="d-flex flex-column h-100 align-items-center">
            <div class="mt-auto">
              <button class="btn btn-success mb-1 w-100" @click="onFilter">
                <font-awesome-icon
                  :icon="['fas', 'filter']"
                ></font-awesome-icon>
                Filtrar
              </button>

              <button
                @click="onPrint"
                class="btn btn-primary mb-1 w-100"
              >
                <font-awesome-icon :icon="['fas', 'print']"></font-awesome-icon>
                Salvar / Imprimir
              </button>

              <modal-extract :params="filters"></modal-extract>

              <button class="btn btn-secondary mb-1 w-100" @click="clearFilter">
                <font-awesome-icon :icon="['fas', 'broom']"></font-awesome-icon>
                Limpar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { computed, onMounted } from 'vue'
  import { useStore } from 'vuex'
  import Dropdown from 'primevue/dropdown'
  import MultiSelect from 'primevue/multiselect'

  import useCompanySectors from '@/modules/CompanySector.js'
  import useCompanyAreas from '@/modules/CompanyArea.js'
  import useCompanyComplements from '@/modules/CompanyComplement.js'
  import useConfinedSpaceTypes from '@/modules/ConfinedSpaceType.js'
  import useConfinedSpaces from '@/modules/ConfinedSpace.js'

  import ModalExtract from '@/components/confined_space/risk_analyses/components/ModalExtract.vue'

  export default {
    emits: ['filter', 'print'],
    components: { ModalExtract, Dropdown, MultiSelect },
    setup(props, { emit }) {
      const store = useStore()
      const selected_company = computed(() => store.getters.selected_company)

      const { filtered_company_sectors, listCompanySectors } = useCompanySectors()
      const {
        filtered_company_areas,
        listCompanyAreasBySector,
        clearFilteredCompanyAreas,
      } = useCompanyAreas()
      const {
        filtered_company_complements,
        listCompanyComplementsByArea,
        clearFilteredCompanyComplements,
      } = useCompanyComplements()

      const { non_paginated_confined_space_types, listConfinedSpaceTypesNoPagination } = useConfinedSpaceTypes()
      const { inventory_filters, listInventory } = useConfinedSpaces()

      onMounted(async () => {
        listCompanySectors(selected_company.value.id)
        listConfinedSpaceTypesNoPagination()
      })

      const onFilter = () => {
        emit('filter', inventory_filters.value)
        listInventory(selected_company.value.id, 1, 10)
      }

      const clearFilter = () => {
        inventory_filters.value = {}
        emit('filter', inventory_filters.value)
        onFilter()
      }

      const onChangeSector = () => {
        inventory_filters.value.area_name = null
        inventory_filters.value.complement_name = null
        clearFilteredCompanyAreas()
        clearFilteredCompanyComplements()

        listCompanyAreasBySector(inventory_filters.value.sector_name)
      }

      const onChangeArea = () => {
        inventory_filters.value.complement_name = null
        clearFilteredCompanyComplements()

        listCompanyComplementsByArea(inventory_filters.value.area_name)
      }

      const onPrint = async () => {
        await emit('print', true)
        await print()
        await emit('print', false)
      }

      const adequacy_status = [
        { label: 'Conforme', value: 0 },
        { label: 'Muito Baixo', value: 1 },
        { label: 'Baixo', value: 2 },
        { label: 'Médio', value: 3 },
        { label: 'Alto', value: 4 },
        { label: 'Muito Alto', value: 5 },
      ]

      return {
        company_sectors: filtered_company_sectors,
        company_areas: filtered_company_areas,
        company_complements: filtered_company_complements,
        non_paginated_confined_space_types,
        filters: inventory_filters,
        clearFilter,
        onFilter,
        onChangeSector,
        onChangeArea,
        onPrint,
        adequacy_status
      }
    },
    data() {
      return {
        loadingPrint: false,
      }
    },
    methods: {
      async print() {
        if (this.loadingPrint) return

        this.loadingPrint = true

        await Promise.all(
          Array.from(document.images)
            .filter((img) => !img.complete)
            .map(
              (img) =>
                new Promise((resolve) => {
                  img.onload = img.onerror = resolve
                }),
            ),
        ).then(() => {
          console.log('images finished loading')
          this.loadingPrint = false
          window.print()
        })
      },

      setConfinedSpaceId(confined_space_id) {
        this.filters.confined_space_id = confined_space_id
      },
    },
  }
</script>

<style lang="scss" scoped>
  label {
    margin: 0;
    font-size: 0.7rem;
  }

  input,
  select,
  .p-multiselect,
  .p-dropdown {
    height: 30px;

    font-size: 0.8rem;
  }

  .p-multiselect,
  .p-dropdown {
    width: 100%;
  }

  ::v-deep(.p-dropdown) {
    .p-dropdown-label,
    .p-inputtext {
      font-size: 0.8rem !important;
      height: 30px;
      // padding: 0.3rem 1rem !important;
      color: #495057 !important;
    }

    .p-dropdown-trigger {
      margin-right: -5px;
    }

    .pi {
      font-size: 0.65rem;
      font-weight: bolder;
    }
  }

  ::v-deep(.multiselect-custom) {
    .p-multiselect-trigger {
      margin-right: -10px;
    }

    .pi {
      font-size: 0.65rem;
      font-weight: bolder;
    }

    .p-multiselect-panel .p-multiselect-header {
      padding: 0.2rem 1.5rem;
    }

    .p-multiselect-item {
      font-size: 0.7rem;
      height: 30px;
    }

    .p-multiselect-token {
      padding: 0.05rem 0.5rem;
    }

    .p-checkbox .p-checkbox-box {
      height: 15px;
      width: 15px;

      .pi {
        font-size: 0.5rem;
      }
    }
  }
</style>

<style type="text/css" media="print">
  @page {
    size: landscape !important;
  }
</style>
